var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEBoost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3149 23.0939L27.9149 40.4938L24.6989 37.2778L21.7709 34.3498L21.7469 34.3258L20.4989 33.0538C19.8029 32.3818 19.4189 31.4698 19.4189 30.4858C19.4189 29.9578 19.5389 29.4298 19.7549 28.9738C19.9229 28.5658 20.1869 28.2058 20.4989 27.8938L22.5389 25.8538L26.5229 21.8699L29.7149 18.6779L35.5949 12.7979C38.7389 16.9499 41.9309 20.3339 45.3149 23.0939Z",
    fill: "#E5B910",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5094 21.9187C39.3894 22.8307 38.6214 23.4787 37.7334 23.4787C37.6614 23.4787 37.5654 23.4547 37.4694 23.4547L26.5254 21.8707L29.7174 18.6787L37.9974 19.8787C38.9814 20.0227 39.6534 20.9347 39.5094 21.9187Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8608 30.318C35.6928 31.182 34.9488 31.782 34.1088 31.782C33.9888 31.782 33.8688 31.758 33.7488 31.734L19.7568 28.974C19.9248 28.566 20.1888 28.206 20.5008 27.894L22.5408 25.854L34.4448 28.206C35.4288 28.398 36.0528 29.334 35.8608 30.318Z",
    fill: "#E5B910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7004 37.2781C24.6284 37.4461 24.5324 37.6141 24.4124 37.7581C23.5004 39.0301 21.5324 40.4941 17.3564 40.1341C11.7884 39.7021 10.4924 41.6701 9.72439 42.8461C9.38839 43.3981 8.81239 43.6861 8.21239 43.6861C7.87639 43.6861 7.54039 43.5901 7.25239 43.3981C6.41239 42.8461 6.17239 41.7421 6.70039 40.9021C8.18839 38.5981 10.7804 36.0061 17.6684 36.5341C19.5644 36.7261 20.9564 36.3901 21.5084 35.6701C21.8444 35.2141 21.8204 34.6141 21.7724 34.3501L24.7004 37.2781Z",
    fill: "#E5B910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6833 31.6071C11.6897 31.6071 10.8833 30.8007 10.8833 29.8071C10.8833 28.8135 11.6897 27.9951 12.6833 27.9951C13.6769 27.9951 14.4833 28.7895 14.4833 29.7831V29.8071C14.4833 30.8007 13.6769 31.6071 12.6833 31.6071Z",
    fill: "#E5B910"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5728 9.41419L52.4928 23.8862C52.4448 24.7501 51.9648 25.4701 51.2208 25.8061C50.9088 25.9741 50.5488 26.0461 50.1648 26.0461C49.6368 26.0461 49.0848 25.8781 48.6048 25.5661C48.4848 25.4701 48.3408 25.3981 48.2208 25.2781L21.8687 51.6301C21.5087 51.9901 21.0527 52.1581 20.5967 52.1581C20.1407 52.1581 19.6847 51.9901 19.3247 51.6301C18.6287 50.9341 18.6287 49.7821 19.3247 49.0861L45.3168 23.0942C41.9328 20.3342 38.7408 16.9502 35.5968 12.7982C35.3568 12.4862 35.1408 12.1742 34.9008 11.8622C34.3008 10.9742 34.1808 9.99019 34.5888 9.19819C34.9248 8.45419 35.6688 7.99819 36.5328 7.92619L51.0048 6.84619H51.1968C51.8208 6.84619 52.4448 7.08619 52.8768 7.54219C53.3808 8.04619 53.6208 8.71819 53.5728 9.41419Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEBoost);
export default __webpack_public_path__ + "static/media/e-boost.f197708cdd411ec99dca76ffa5c0871c.svg";
export { ForwardRef as ReactComponent };